// src/pages/TermsAndConditions.js
import React from "react";
import SEO from "../components/SEO";

const TermsAndConditions = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions | Oolook"
        description="Official Terms and Conditions for the use of Oolook's services, platform, and APIs. This document governs your rights and obligations as a user."
        noIndex={false}
      />
      <main className="relative isolate bg-dark-bg px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <article className="prose prose-invert lg:prose-lg prose-headings:font-bold prose-a:text-dark-accent-start hover:prose-a:text-dark-accent-end">
            <h1>Terms and Conditions</h1>
            <p className="lead">Last Updated and Effective Date: 24 April 2025</p>

            <h2>1. Agreement to Terms</h2>
            <p>
              These Terms and Conditions ("Terms") constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you” or “User”), and Oolook Ltd. (“Oolook,” “we,” “us,” or “our”), concerning your access to and use of the Oolook platform, including any website, mini-tools, APIs, or mobile applications (collectively, the “Services”). You agree that by accessing the Services, you have read, understood, and agreed to be bound by all of these Terms. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
            </p>

            <h2>2. User Accounts and Responsibilities</h2>
            <p>
              To access most features of the Services, you must register for an account. You agree to provide accurate, current, and complete information during the registration process. You are solely responsible for safeguarding your account password and for any activities or actions under your account. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
            </p>
            
            <h2>3. Subscription, Fees, and Payment</h2>
            <h4>3.1. Subscription Plans</h4>
            <p>Our Services are offered on a subscription basis. By selecting a paid plan, you agree to pay Oolook the monthly or annual subscription fees indicated for that service. Payments will be charged on a pre-pay basis on the day you sign up for a paid plan and will cover the use of that service for a monthly or annual subscription period as indicated.</p>
            <h4>3.2. Automatic Renewal</h4>
            <p>Unless you notify Oolook before the end of the applicable subscription period that you want to cancel, your subscription will automatically renew and you authorize us to collect the then-applicable annual or monthly subscription fee (as well as any taxes) using any credit card or other payment mechanism we have on record for you.</p>
            <h4>3.3. Cancellations and Refunds</h4>
            <p>You may cancel your subscription at any time. Subscription fees are non-refundable except as required by law or as otherwise determined by us in our sole discretion.</p>

            <h2>4. Intellectual Property Rights</h2>
            <h4>4.1. Our IP</h4>
            <p>The Services and their entire contents, features, and functionality (including but not limited to all information, software, text, displays, images, video, and audio, and the design, selection, and arrangement thereof) are owned by Oolook, its licensors, or other providers of such material and are protected by international copyright, trademark, patent, and other intellectual property laws.</p>
            <h4>4.2. Your User Content</h4>
            <p>You retain all ownership rights to the content you upload or generate ("User Content"). However, by using the Services, you grant Oolook a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and distribute your User Content solely for the purpose of providing, maintaining, and improving the Services. This includes using User Content to train and enhance our AI models. We will take steps to anonymize User Content where feasible.</p>
            
            <h2>5. Acceptable Use Policy</h2>
            <p>You agree not to use the Services to:</p>
            <ul>
              <li>Create or transmit any content that is unlawful, harmful, defamatory, obscene, or infringing on the rights of others.</li>
              <li>Generate misinformation, spam, or content for illicit or deceptive purposes.</li>
              <li>Attempt to reverse-engineer, decompile, or otherwise discover the source code of the Services or our AI models.</li>
              <li>Violate any applicable national or international law or regulation.</li>
            </ul>

            <h2>6. Disclaimer of Warranties</h2>
            <p>
              THE SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. OOLOOK EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>

            <h2>7. Limitation of Liability</h2>
            <p>
              IN NO EVENT SHALL OOLOOK, ITS AFFILIATES, DIRECTORS, OR EMPLOYEES, BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE SERVICES.
            </p>

            <h2>8. Governing Law</h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions.
            </p>
            
            <h2>9. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice prior to any new terms taking effect. By continuing to access or use our Services after those revisions become effective, you agree to be bound by the revised terms.
            </p>

            <h2>10. Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at <a href="mailto:legal@oolook.in">legal@oolook.in</a>.
            </p>
          </article>
        </div>
      </main>
    </>
  );
};

export default TermsAndConditions;